import { LIST_WEB_ACTIONS } from '../consts/listWebActions'

export * as conversationActions from './conversationActions'

// User Actions
export function setClientId(clientId) {
  return {
    type: 'SET_CLIENT_ID',
    clientId
  };
}

export function setConnectionState(state, connected) {
  return {
    type: 'SET_CONNECTION_STATE',
    state,
    connected
  };
}

export function playSfxById(id, pod) {
  return {
    type: 'PLAY_SFX_BY_ID',
    id,
    pod
  };
}

export function setStateFromServer(state) {
  return {
    type: 'SET_STATE_FROM_SERVER',
    state
  };
}

export function setPersistantStateFromServer(state) {
  return {
    type: 'SET_PERSISTANT_STATE_FROM_SERVER',
    state
  };
}

export function setActiveCategory(data) {
  return {
    type: 'SET_ACTIVE_CATEGORY',
    category: data.category,
  };
}

export function setActiveTreeItem(id) {
  return {
    type: 'SET_ACTIVE_TREE_ITEM',
    id,
  };
}

export function createSession(missionKey, mode) {
  return {
    type: 'UP_CREATE_SESSION',
    missionKey,
    mode,
    meta: {
      sendServer: true,
    },
  }
}

export function selectRoom(id) {
  return {
    type: 'SELECT_ROOM',
    id,
    meta: {
      sendServer: false,
    },
  }
}

export function joinSession(id) {
  return {
    type: 'UP_JOIN_SESSION',
    id,
    meta: {
      sendServer: true,
    }
  }
}

export function upStartActivity() {
  return {
    type: 'UP_START_ACTIVITY',
    meta: {
      sendServer: true,
    }
  }
}

export function pushStartActivity(activityId) {
  return {
    type: 'PUSH_START_ACTIVITY',
    activityId: activityId,
    meta: {
      sendClient: true,
    }
  }
}

export function cltCheckLeaveSession() {
  return {
    type: 'CLT_CHECK_LEAVE_SESSION',
  }
}

export function upLeaveSession() {
  return {
    type: 'UP_LEAVE_SESSION',
    meta: {
      sendServer: true,
    }
  }
}

export function setCurrentSession(id) {
  return {
    type: 'SET_CURRENT_SESSION',
    id
  };
}

export function setCurrentScene(scene) {
  return {
    type: 'SET_CURRENT_SCENE',
    scene
  };
}


export function addActivity(templateActivityId) {
  return {
    type: 'ADD_ACTIVITY',
    templateActivityId,
    meta: {
      sendServer: true,
    }
  };
}

export function selectActivity(id) {
  return {
    type: 'SELECT_ACTIVITY',
    id,
    meta: {
      sendServer: true,
    }
  };
}

export function pushActivityContent(data) {
  return {
    type: 'PUSH_ACTIVITY_CONTENT',
    data,
    meta: {
      sendServer: false,
      sendClient: true,
    }
  };
}

export function pushPadActivityContent(data) {
  return {
    type: 'PUSH_PAD_ACTIVITY_CONTENT',
    data,
    meta: {
      sendServer: false,
      sendClient: false,
      sendPad: true,
    }
  };
}

export function pushActivities(activities) {
  return {
    type: 'PUSH_ACTIVITIES',
    activities,
    meta: {
      sendClient: true,
    }
  };
}

export function pushSessionState(state, playerNumber) {
  return {
    type: 'PUSH_SESSION_STATE',
    state,
    playerNumber,
    meta: {
      sendClient: true,
    }
  }
}


export function pushInstanceList(list) {
  return {
    type: 'PUSH_SESSION_LIST',
    list,
    meta: {
      sendClient: true,
    }
  }
}


export function pushPlaylistState(state) {
  return {
    type: 'PUSH_PLAYLIST_STATE',
    state,
    meta: {
      sendClient: true,
    }
  }
}

// Additional Panels
export const openAdditionalPanel = key => ({
  type: 'OPEN_ADDITIONAL_PANEL',
  key,
})

export const closeAdditionalPanel = key => ({
  type: 'CLOSE_ADDITIONAL_PANEL',
  key,
})

export const toggleAdditionalPanel = key => ({
  type: 'TOGGLE_ADDITIONAL_PANEL',
  key,
})

export const setContentPanel = name => ({
  type: 'SET_CONTENT_PANEL',
  name,
})

export const openFolder = id => ({
  type: 'OPEN_FOLDER',
  id,
})

export const goHome = () => ({
  type: 'GO_HOME'
})

export const applyHome = () => ({
  type: 'APPLY_HOME'
})

export const goSceneHome = () => ({
  type: 'GO_SCENE_HOME'
})

export const goBackFolder = (id) => ({
  type: 'GO_BACK_FOLDER',
  id
})
export const openLink = (id) => ({
  type: 'OPEN_LINK',
  id,
})

export const setLinkStatus = (id, status) => ({
  type: 'SET_LINK_STATUS',
  id,
  status
})

export const openStaticLink = (id) => ({ type: 'OPEN_STATIC_LINK', id })

export const triggerCustomEvent = (key) => ({ type: 'TRIGGER_CUSTOM_EVENT', key })
export const upTriggerCustomEvent = (key) => ({ type: 'UP_TRIGGER_CUSTOM_EVENT', key, meta: { sendServer: true } })
export const triggerCustomNetworkEvent = (key) => ({
  type: 'TRIGGER_CUSTOM_NETWORK_EVENT',
  key,
  meta: { sendServer: true }
})
export const downCustomEvent = (key) => ({ type: 'DOWN_CUSTOM_EVENT', key, meta: { sendClient: true } })
// Server
export const setCurrentStage = (stage) => ({ type: 'SET_CURRENT_STAGE', stage }) // SRV SIDE AND WILL BE SENT TO CLIENTS
export const debugShowCore = () => ({ type: 'DEBUG_SHOW_CORE' })